/* eslint-disable max-lines */
import {
  DEFAULT_SIZES,
  DATA_TYPE,
  COMPONENT_TYPE,
  WIDTH,
  HEIGHT,
  SUBDATA_TYPE,
} from '@/store/modules/cards/constants';

/*
  Property of allowCards objects:

  id: String,
  width: Enum DEFAULT_SIZES,
  height: Enum DEFAULT_SIZES,
  component: String,
  visible: Boolean,
  hideExpandButton: Boolean,
  hideResizeButton: Boolean,
  notSupportFilter: Boolean,
  dataType: Enum DATA_TYPE,
  subType: Enum SUBDATA_TYPE,
  props: Object,
*/
export default [
  {
    id: 'BLIP_1',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    props: {
      title: 'Mensagens Recebidas',
      originalTitle: 'Mensagens Recebidas',
      isExpandedCard: false,
      description: 'Total de mensagens recebidas no periodo (dos contatos para o bot).',
      servicePath: 'getReceivedMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_2',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    props: {
      title: 'Mensagens Enviadas',
      originalTitle: 'Mensagens Enviadas',
      isExpandedCard: false,
      description: 'Total de mensagens enviadas no periodo (do bot para os contatos).',
      servicePath: 'getSentMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_3',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.ACTV_MESSAGES,
    props: {
      title: 'Mensagens Ativas',
      originalTitle: 'Mensagens Ativas',
      isExpandedCard: false,
      description: 'Total de mensagens ativas enviadas no período (24 horas após a última interação do contato).',
      servicePath: 'getActiveMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_4',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Total de Contatos Únicos no Período',
      originalTitle: 'Total de Contatos Únicos no Período',
      isExpandedCard: false,
      description: 'Total de contatos únicos no período, que receberam ou enviaram mensagem para o bot.',
      servicePath: 'getActiveIdentity',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_5',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BaseBlipVariationChart',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Contatos com Interação no Período',
      originalTitle: 'Contatos com Interação no Período',
      isExpandedCard: false,
      description: 'Total de contatos únicos no período, que enviaram mensagem para o bot.',
      servicePath: 'getEngagedIdentity',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_6',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Contatos Únicos por Intervalo',
      originalTitle: 'Contatos Únicos por Intervalo',
      isExpandedCard: false,
      description: 'Contatos únicos por intervalo (dia ou mês), que receberam ou enviaram mensagem para o bot.',
      servicePath: 'getActiveIdentity',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_7',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Contatos com Interação por Intervalo',
      originalTitle: 'Contatos com Interação por Intervalo',
      isExpandedCard: false,
      description: 'Contatos únicos por intervalo (dia ou mês), que enviaram mensagem para o bot.',
      servicePath: 'getEngagedIdentity',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_8',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    props: {
      title: 'Mensagens Enviadas por Intervalo',
      originalTitle: 'Mensagens Enviadas por Intervalo',
      isExpandedCard: false,
      description: 'Mensagens enviadas por intervalo (dia ou mês), do bot para os contatos.',
      servicePath: 'getSentMessages',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_9',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    props: {
      title: 'Mensagens Recebidas por Intervalo',
      originalTitle: 'Mensagens Recebidas por Intervalo',
      isExpandedCard: false,
      description: 'Mensagens recebidas por intervalo (dia ou mês), do bot para os contatos.',
      servicePath: 'getReceivedMessages',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_10',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseBlipLineChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.ACTV_MESSAGES,
    props: {
      title: 'Mensagens Ativas por Intervalo',
      originalTitle: 'Mensagens Ativas por Intervalo',
      isExpandedCard: false,
      description: 'Mensagens ativas enviadas por intervalo (dia ou mês), 24 horas após a última interação do contato.',
      servicePath: 'getActiveMessages',
      interval: 'D',
    },
  },
  {
    id: 'BLIP_11',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipMessageVolumeInPeriod',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    props: {
      title: 'Volume de mensagens no período',
      originalTitle: 'Volume de mensagens no período',
      isExpandedCard: false,
      description: 'Gráfico de linha com o total de mensagens enviadas e recebidas, dentro do período selecionado.',
      servicePath: 'getReceivedAndSentMessages',
    },
  },
  {
    id: 'BLIP_12',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipNonEngagedContacts',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Contatos que não responderam',
      originalTitle: 'Contatos que não responderam',
      isExpandedCard: false,
      description: 'Total de contatos únicos que não responderam a nenhuma mensagem enviada pelo chatbot e não iniciaram nenhuma conversa, no período selecionado.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_13',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipEngagedAndNonEngagedContacts',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Contatos com interação x Contatos que não responderam',
      originalTitle: 'Contatos com interação x Contatos que não responderam',
      isExpandedCard: false,
      description: 'Gráfico de linha com o total de contatos únicos que não responderam e contatos únicos que interagiram com o chatbot, dentro do período selecionado.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_14',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipRejectionRate',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Taxa de rejeição',
      originalTitle: 'Taxa de rejeição',
      isExpandedCard: false,
      description: 'Cálculo da porcentagem do total de contatos únicos que não responderam ao chatbot dividido pelo número total de contatos únicos no período selecionado. Calculado através da seguinte fórmula: Total de Contatos que não responderam / Total de contatos únicos * 100%.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_15',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipActiveMessagesByChannel',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.ACTV_MESSAGES,
    props: {
      title: 'Mensagens ativas por canal',
      originalTitle: 'Mensagens ativas por canal',
      isExpandedCard: false,
      description: 'Tabela com o total de mensagens ativas enviadas por canal no período de tempo selecionado. São consideradas mensagens ativas as mensagens que foram enviadas pelo chatbot após 24 horas do recebimento da última mensagem enviada pelo contato.',
      servicePath: 'getActiveMessagesPerDomain',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_16',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipEngagementRate',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    props: {
      title: 'Taxa de interação',
      originalTitle: 'Taxa de interação',
      isExpandedCard: false,
      description: 'Cálculo da porcentagem do total de contatos únicos que responderam e interagiram com o chatbot sobre o número total de contatos únicos no período selecionado. Calculado através da seguinte fórmula: Total de Contatos com Interação / Total de contatos únicos * 100%.',
      servicePath: 'getMetricsContacts',
    },
  },
  {
    id: 'BLIP_17',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipTotalSentAndReceivedMessages',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    props: {
      title: 'Total de mensagens trafegadas',
      originalTitle: 'Total de mensagens trafegadas',
      isExpandedCard: false,
      description: 'Total de mensagens enviadas e recebidas pelo chatbot no fluxo conversacional. Inclui, também, mensagens trafegadas no Blip Desk, entre os contatos e atendentes.',
      servicePath: 'getReceivedAndSentMessages',
      interval: 'NI',
    },
  },
  {
    id: 'BLIP_18',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipEventTrackCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.EVENTS,
    isEvent: true,
    props: {
      title: 'Total de Eventos Personalizados',
      originalTitle: 'Total de Eventos Personalizados',
      isExpandedCard: false,
      description: 'Número total de Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
      servicePath: 'getEventTrackCount',
    },
  },
  {
    id: 'BLIP_19',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipEventTrackHorizontalStackedBar',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.EVENTS,
    isEvent: true,
    props: {
      title: 'Distribuição de Eventos Personalizados',
      originalTitle: 'Distribuição de Eventos Personalizados',
      isExpandedCard: false,
      description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
      servicePath: 'getEventTrack',
    },
  },
  {
    id: 'BLIP_20',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipEventTrackPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.EVENTS,
    isEvent: true,
    props: {
      title: 'Distribuição de Eventos Personalizados (Percentual)',
      originalTitle: 'Distribuição de Eventos Personalizados (Percentual)',
      isExpandedCard: false,
      description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
      servicePath: 'getEventTrack',
    },
  },
  {
    id: 'BLIP_21',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipEventTrackInTime',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.EVENTS,
    isEvent: true,
    props: {
      title: 'Eventos Personalizados no Tempo',
      originalTitle: 'Eventos Personalizados no Tempo',
      isExpandedCard: false,
      description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, ao longo de um período de tempo. Atenção: Apenas as 50 ações mais numerosas são mostradas.',
      servicePath: 'getEventTrack',
    },
  },
  {
    id: 'BLIP_22',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipCampaignsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.ACTV_MESSAGES,
    props: {
      title: 'Minhas Campanhas',
      originalTitle: 'Minhas Campanhas',
      isExpandedCard: false,
      description: 'Total de campanhas ativas enviadas e agendadas através dos contatos inteligentes no período selecionado.',
      servicePath: 'getAudienceSummary',
    },
    desk: {
      notSupportDeskFilters: true,
    },
    audience: {
      suportScheduledFilters: true,
    },
  },
  {
    id: 'BLIP_23',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets abertos',
      originalTitle: 'Tickets abertos',
      isExpandedCard: false,
      description: 'Total de tickets que foram abertos no período selecionado.',
      servicePath: 'getReportsTickets',
      ticketType: ['open'],
    },
  },
  {
    id: 'BLIP_24',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets perdidos',
      originalTitle: 'Tickets perdidos',
      isExpandedCard: false,
      description: 'Total de atendimentos que foram encerrados pelo cliente enquanto ele ainda estava na fila de atendimento e ainda não havia sido atribuído a um atendente.',
      servicePath: 'getReportsTickets',
      ticketType: ['missed'],
    },
  },
  {
    id: 'BLIP_25',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets abandonados',
      originalTitle: 'Tickets abandonados',
      isExpandedCard: false,
      description: 'Total de atendimentos que foram encerrados pelo cliente e depois foram distribuídos ou puxados por um atendente.',
      servicePath: 'getReportsTickets',
      ticketType: ['closedClient'],
    },
  },
  {
    id: 'BLIP_26',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets atendidos',
      originalTitle: 'Tickets atendidos',
      isExpandedCard: false,
      description: 'Total de atendimentos que foram finalizados ou transferidos para outra fila ou atendente.',
      servicePath: 'getReportsTickets',
      ticketType: ['closedAttendant', 'transferred'],
    },
  },
  {
    id: 'BLIP_27',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets fechados',
      originalTitle: 'Tickets fechados',
      isExpandedCard: false,
      description: 'Total da soma dos atendimentos perdidos, abandonados e atendidos.',
      servicePath: 'getReportsTickets',
      ticketType: ['closed'],
    },
  },
  {
    id: 'BLIP_28',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipConversionFunnel',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.ACTV_MESSAGES,
    props: {
      title: 'Funil de conversão',
      originalTitle: 'Funil de conversão',
      isExpandedCard: false,
      description: 'Apresenta métricas de desempenho por etapa dos envios de mensagens ativas realizados pelos contatos inteligentes selecionados.',
      servicePath: 'getAudienceSummary',
    },
    desk: {
      notSupportDeskFilters: true,
    },
    audience: {
      suportScheduledFilters: true,
    },
  },
  {
    id: 'BLIP_29',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo máximo na fila',
      originalTitle: 'Tempo máximo na fila',
      isExpandedCard: false,
      description: 'Apresenta o maior tempo que um cliente esperou na fila até ser distribuído ou ser puxado por um atendente. Para chegar nesse número são considerados apenas os tickets fechados no período selecionado, que já foram removidos da tela do atendente.',
      servicePath: 'getReportsTimings',
      timingType: 'maxQueueTime',
    },
  },
  {
    id: 'BLIP_30',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo máximo até 1ª resposta',
      originalTitle: 'Tempo máximo até 1ª resposta',
      isExpandedCard: false,
      description: 'Apresenta o máximo de tempo que um cliente levou para receber o primeiro contato do atendente depois de ter sido distribuído ou puxado pelo atendente. Para chegar nesse número são considerados apenas os tickets fechados no período selecionado, que já foram removidos da tela do atendente.',
      servicePath: 'getReportsTimings',
      timingType: 'maxFirstResponseTime',
    },
  },
  {
    id: 'BLIP_31',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsAverageTimings',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo médio na fila',
      originalTitle: 'Tempo médio na fila',
      isExpandedCard: false,
      description: 'Tempo médio que os clientes estão aguardando na fila até serem atribuídos a um atendente. O cálculo desta métrica considera os tempos apenas dos tickets fechados no período selecionado, que já foram removidos da tela do atendente.',
      servicePath: 'getReportsTimings',
      timingType: 'avgQueueTime',
    },
  },
  {
    id: 'BLIP_32',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsAverageTimings',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo médio até 1ª resposta',
      originalTitle: 'Tempo médio até 1ª resposta',
      isExpandedCard: false,
      description: 'Tempo médio que os atendentes estão levando para enviar a primeira mensagem para o cliente depois que eles são atribuídos ao atendente. O cálculo desta métrica considera os tempos apenas dos tickets fechados no período selecionado, que receberam uma primeira resposta do atendente e que já foram removidos da tela do atendente.',
      servicePath: 'getReportsTimings',
      timingType: 'avgFirstResponseTime',
    },
  },
  {
    id: 'BLIP_33',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsAverageTimings',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo médio de espera',
      originalTitle: 'Tempo médio de espera',
      isExpandedCard: false,
      description: 'Tempo médio que um cliente demora para receber o primeiro atendimento, é a diferença entre o momento que o atendimento é distribuído para uma fila de atendimento até o momento que o atendente envia a primeira resposta.',
      servicePath: 'getReportsTimings',
      timingType: 'avgWaitTime',
    },
  },
  {
    id: 'BLIP_34',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsAverageTimings',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo médio de resposta',
      originalTitle: 'Tempo médio de resposta',
      isExpandedCard: false,
      description: 'Tempo médio que os atendentes estão levando para responder as mensagens do cliente. O cálculo desta métrica considera apenas tickets que tiveram pelo menos uma interação completa entre cliente e atendente, ou seja, tickets em que o cliente mandou mensagem e o atendente respondeu, e que foram fechados no período selecionado, e já foram removidos da tela do atendente.',
      servicePath: 'getReportsTimings',
      timingType: 'avgResponseTime',
    },
  },
  {
    id: 'BLIP_35',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipReportsAverageTimings',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tempo médio de atendimento',
      originalTitle: 'Tempo médio de atendimento',
      isExpandedCard: false,
      description: 'O cálculo desta métrica considera apenas os tempos dos tickets fechados no período, que já foram removidos da tela do atendente.',
      servicePath: 'getReportsTimings',
      timingType: 'avgAttendanceTime',
    },
  },
  {
    id: 'BLIP_36',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BlipReportsTicketsInTime',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Volume de tickets por dia',
      originalTitle: 'Volume de tickets por dia',
      isExpandedCard: false,
      description: 'Quantidade de tickets abertos e fechados por dia dentro do período de tempo selecionado.',
      servicePath: 'getReportsTickets',
    },
  },
  {
    id: 'BLIP_37',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipDeskProductivityTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Disponibilidade de atendentes',
      originalTitle: 'Disponibilidade de atendentes',
      isExpandedCard: false,
      description: 'Relatório com o tempo que cada atendente passou em cada status para trazer uma visão de disponibilidade dos mesmos no período de tempo selecionado.',
      servicePath: 'getReportsAttendantsProductivity',
    },
    desk: {
      notSupportDeskFilters: true,
    },
  },
  {
    id: 'BLIP_38',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipReportsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Relatórios de atendimentos - Atendentes',
      originalTitle: 'Relatórios de atendimentos - Atendentes',
      isExpandedCard: false,
      description: 'Relatório de tickets finalizados e suas respectivas métricas por Atendente dentro do período de tempo selecionado.',
      servicePath: 'getReportsAttendants',
      reportType: 'attendants',
    },
  },
  {
    id: 'BLIP_39',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipReportsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Relatórios de atendimentos - Filas',
      originalTitle: 'Relatórios de atendimentos - Filas',
      isExpandedCard: false,
      description: 'Relatório de tickets finalizados e suas respectivas métricas por Fila dentro do período de tempo selecionado.',
      servicePath: 'getReportsTeams',
      reportType: 'teams',
    },
  },
  {
    id: 'BLIP_40',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BlipReportsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Relatórios de atendimentos - Tags',
      originalTitle: 'Relatórios de atendimentos - Tags',
      isExpandedCard: false,
      description: 'Relatório de tickets finalizados e suas respectivas métricas por Tag dentro do período de tempo selecionado.',
      servicePath: 'getReportsTags',
      reportType: 'tags',
    },
  },
  {
    id: 'BLIP_41',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipMonitoringTicketMetrics',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets por atendente',
      originalTitle: 'Tickets por atendente',
      isExpandedCard: false,
      description: 'Média de tickets que estão com os atendentes no momento..',
      servicePath: 'getMonitoringTicketMetrics',
      monitoringType: 'ticketsPerAttendant',
    },
    desk: {
      notSupportedOperators: true,
    },
  },
  {
    id: 'BLIP_42',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipMonitoringTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Volume de tickets na fila',
      originalTitle: 'Volume de tickets na fila',
      isExpandedCard: false,
      description: 'Quantidade de tickets nas filas de atendimento, será considerado o total de tickets que ainda não foram atribuídos de todas as filas deste bot, ou das filas que estiverem filtradas.',
      servicePath: 'getMonitoringTickets',
      monitoringType: 'waiting',
    },
    desk: {
      notSupportedOperators: true,
    },
  },
  {
    id: 'BLIP_43',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipMonitoringTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Tickets em atendimento',
      originalTitle: 'Tickets em atendimento',
      isExpandedCard: false,
      description: 'Quantidade total de tickets que estão em atendimento no momento, ou seja, já foram distribuídos ou puxados pelo atendente, e já receberam a primeira resposta do atendente, mas ainda não foram encerrados.',
      servicePath: 'getMonitoringTickets',
      monitoringType: 'inAttendance',
    },
    desk: {
      notSupportedOperators: true,
    },
  },
  {
    id: 'BLIP_44',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipMonitoringTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Atendentes online',
      originalTitle: 'Atendentes online',
      isExpandedCard: false,
      description: 'Quantidade de Atendentes que estão ativos e aptos a receber novos atendimentos.',
      servicePath: 'getAttendantStatus',
      monitoringType: 'online',
    },
    desk: {
      notSupportedOperators: true,
    },
  },
  {
    id: 'BLIP_45',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipMonitoringTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Atendentes em pausa',
      originalTitle: 'Atendentes em pausa',
      isExpandedCard: false,
      description: 'Quantidade de Atendentes que estão em alguma pausa, seja a pausa padrão ou alguma pausa personalizada, como almoço, banheiro, etc e por isso não recebem novos atendimentos.',
      servicePath: 'getAttendantStatus',
      monitoringType: 'pause',
    },
    desk: {
      notSupportedOperators: true,
    },
  },
  {
    id: 'BLIP_46',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BlipMonitoringTicketsCount',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Atendentes offline',
      originalTitle: 'Atendentes offline',
      isExpandedCard: false,
      description: 'Quantidade de Atendentes que estão inativos e não podem receber novos atendimentos.',
      servicePath: 'getAttendantStatus',
      monitoringType: 'offline',
    },
    desk: {
      notSupportedOperators: true,
    },
  },
  {
    id: 'BLIP_47',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipOpenTicketsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Gestão de atendimento - Atribuído/Em Atendimento',
      originalTitle: 'Gestão de atendimento - Atribuído/Em Atendimento',
      isExpandedCard: false,
      description: 'Listagem de atendimentos que já foram atribuídos a um atendente e os atendimentos que estão em andamento.',
      servicePath: 'getOpenTickets',
    },
  },
  {
    id: 'BLIP_48',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipWaitingTicketsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Gestão de atendimento - Aguardando atendimento',
      originalTitle: 'Gestão de atendimento - Aguardando atendimento',
      isExpandedCard: false,
      description: 'Listagem de atendimentos que estão na fila de atendimento e ainda não foram atribuídos a um atendente.',
      servicePath: 'getWaitingTickets',
    },
  },
  {
    id: 'BLIP_49',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipMonitoringAttendantsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Gestão de atendimento - Atendentes',
      originalTitle: 'Gestão de atendimento - Atendentes',
      isExpandedCard: false,
      description: 'Listagem de atendimentos que já foram atribuídos separados por atendente.',
      servicePath: 'getMonitoringAttendants',
    },
  },
  {
    id: 'BLIP_50',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipMonitoringTeamsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Gestão de atendimento - Filas',
      originalTitle: 'Gestão de atendimento - Filas',
      isExpandedCard: false,
      description: 'Listagem de atendimentos separados por fila.',
      servicePath: 'getMonitoringTeams',
    },
  },
  {
    id: 'BLIP_51',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BlipTagsMetricsTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.BLIP,
    subDataType: SUBDATA_TYPE.BLIP.HUMAN_SERVICE,
    props: {
      title: 'Gestão de atendimento - Tags',
      originalTitle: 'Gestão de atendimento - Tags',
      isExpandedCard: false,
      description: 'Listagem de atendimentos que já foram finalizados separados por tags.',
      servicePath: 'getTagsMetrics',
    },
  },
];
